import React from 'react';

interface Props {
  title: string;
  icon: string;
  iconBg?: string;
  onClose: () => void;
  children: React.ReactNode;
}

const RpPanelWrap: React.FC<Props> = ({ title, icon, iconBg = 'rgba(37,99,235,.1)', onClose, children }) => (
  <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
    <div className="rp-panel-head">
      <div className="rp-panel-icon" style={{ background: iconBg }}>{icon}</div>
      <div className="rp-panel-title">{title}</div>
      <button type="button" className="rp-panel-close" onClick={onClose} title="Close">✕</button>
    </div>
    <div className="rp-panel-body">{children}</div>
  </div>
);

export default RpPanelWrap;
